import React from "react";
import { Box, Typography, Divider } from "@material-ui/core";
import { getLang } from "app/feature/constants";
import CampaignTngDisbursementTable from "../../table/campaignTngDisbursementTable";

export default function CampaignTngDisbursementPanelComponent({
  lang,
  campaignLogs,
  totalFiltered,
  isFetching,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  tableFilter,
  handleReload,
  paginationOptions,
  handleExport,
  disbursementInfo,
}) {
  return (
    <Box>
      <Box>
        <Typography variant="body1">
          <b>{getLang(lang, "label.CAMPAIGN_TNG_DISBURSEMENT_TITLE")}</b>
        </Typography>
      </Box>
      <Box mt={1} mb={2}>
        <Divider />
      </Box>
      <Box mb={1.5}>
        <Typography variant="body2">
          {getLang(lang, "paragraph.CAMPAIGN_TNG_DISBURSEMENT_DESC")}
        </Typography>
      </Box>
      <Box>
        <CampaignTngDisbursementTable
          rows={campaignLogs}
          isFetching={isFetching}
          isError={isError}
          handleReload={handleReload}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalFiltered={totalFiltered}
          paginationOptions={paginationOptions}
          tableFilter={tableFilter}
          lang={lang}
          handleExport={handleExport}
          disbursementInfo={disbursementInfo}
        />
      </Box>
    </Box>
  );
}
